import { Injectable } from '@angular/core';

declare global {
  interface Window {
    clarity?: (...args: unknown[]) => void;
  }
}

@Injectable({
  providedIn: 'root',
})
export class ClarityLoaderService {
  private loaded = false;
  private projectId: string | null = null;

  enable(projectId: string): void {
    if (!projectId?.trim() || typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    if (this.loaded && this.projectId === projectId) {
      this.grantConsent();
      return;
    }

    if (document.getElementById('clarity-loader')) {
      this.loaded = true;
      this.projectId = projectId;
      this.grantConsent();
      return;
    }

    const script = document.createElement('script');
    script.id = 'clarity-loader';
    script.type = 'text/javascript';
    script.async = true;
    script.text = `
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "${projectId}");
    `;
    document.head.appendChild(script);
    this.loaded = true;
    this.projectId = projectId;
    this.grantConsent();
  }

  disable(): void {
    this.revokeConsent();
  }

  isLoaded(): boolean {
    return this.loaded || !!document.getElementById('clarity-loader');
  }

  /** Compatibilidad con código existente. */
  load(projectId: string): void {
    this.enable(projectId);
  }

  private grantConsent(): void {
    if (typeof window !== 'undefined' && typeof window.clarity === 'function') {
      window.clarity('consent', true);
    }
  }

  private revokeConsent(): void {
    if (typeof window !== 'undefined' && typeof window.clarity === 'function') {
      window.clarity('consent', false);
    }
  }
}
